// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LB-z","hovered":"MB-z","hoverImage":"NB-z","mainImage":"OB-z","imageNoBackground":"PB-z","fullSizeImage":"QB-z"};